{
  "content.title": "Contenido",
  "content.empty": "No hay contenido todavía."
}
